import { render, staticRenderFns } from "./CreateNomenclatureDish.vue?vue&type=template&id=efd3ab0e&scoped=true"
import script from "./CreateNomenclatureDish.vue?vue&type=script&lang=js"
export * from "./CreateNomenclatureDish.vue?vue&type=script&lang=js"
import style0 from "./CreateNomenclatureDish.vue?vue&type=style&index=0&id=efd3ab0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd3ab0e",
  null
  
)

export default component.exports